import { PriceLevel, Link } from "../models"
export class Category {
	storageId: string
	uuid: string
	name: string
	type: string
	vat: number;
	color: string;
	public _links: {
		self: Link
		deleteWithReference: Link
		standardPriceLevel: Link
		reducedPriceLevels: Link
	}
}



// WEBPACK FOOTER //
// ./src/app/models/category.model.ts